/* eslint-disable max-classes-per-file */
export type ApFindControlPkValue = ApFindControlSinglePk | ApFindControlMultiPk;

export class ApFindControlSinglePk {
  readonly isList: false = false;
  constructor(
    readonly value: string | null
  ) {
  }
}

export class ApFindControlMultiPk {
  readonly isList: true = true;
  constructor(
    readonly value: string[]
  ) {
  }
}

// use this function to create an ApFindControlObjectValue
export function createFindControlObjectValue<TFindControlObject>(
  value: TFindControlObject | TFindControlObject[] | null,
): ApFindControlObjectValue<TFindControlObject> {
  if (!value) {
    return null;
  }
  if (!Array.isArray(value)) {
    return new ApFindControlSingleObject(value);
  }
  if (!value.length) {
    return null;
  }

  return new ApFindControlMultiObject(value);
}

// null represents an empty value, so that it will work properly with Validators.required
export type ApFindControlObjectValue<TFindControlObject> =
  null |
  ApFindControlSingleObject<TFindControlObject> |
  ApFindControlMultiObject<TFindControlObject>;

class ApFindControlSingleObject<TFindControlObject> {
  readonly isList: false = false;
  constructor(
    readonly value: TFindControlObject
  ) {
  }
  getAsList(): TFindControlObject[] {
    return [this.value];
  }
  getFirstItem(): TFindControlObject {
    return this.value;
  }
}

class ApFindControlMultiObject<TFindControlObject> {
  readonly isList: true = true;
  constructor(
    readonly value: TFindControlObject[]
  ) {
  }
  getAsList(): TFindControlObject[] {
    return this.value;
  }
  getFirstItem(): TFindControlObject {
    return this.value[0];
  }
}

